import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  FilterValue,
  InputType,
  PeriodFilterValue,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import dayjs from "dayjs";

const PERIOD_ID = "period";

export function usePeriodFilter(
  showPeriod: boolean,
  filterValues: FilterValue[]
) {
  const { t } = useTranslation();
  const defaultValue = { filterId: PERIOD_ID, value: "" };

  const today = dayjs().format("YYYY-MM-DD");
  const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

  const filterValue = filterValues.find(
    (value) => value.filterId === PERIOD_ID
  ) as PeriodFilterValue;

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: PERIOD_ID,
      title: t("periodString"),
      options: [
        {
          value: "currentTertial",
          title: t("currentTertialString"),
        },
        {
          value: "previousTertial",
          title: t("previousTertialString"),
        },
        {
          value: "custom",
          title: t("customTitleString"),
          startDate: filterValue?.startDate ?? yesterday,
          endDate: filterValue?.endDate ?? today,
        },
      ],
      enabled: showPeriod,
      defaultValue,
    },
    t("todayString")
  );
}
